import React from "react";

import { custom } from "@/mappings/plans";
import { cx } from "@/utils";
import Modal, { ModalContent, ModalHeader } from "@components/Modal";
import { ModalProps } from "@components/Modal/Modal";

import { ContactSalesCta } from "../../PlanModal";
import * as PlanCard from "../../PlanModal/PlanCard";

import styles from "./UpsaleModals.module.css";

const CustomPlanModal = (props: Partial<ModalProps>) => {
  return (
    <PlanCard.Root plan={custom}>
      <Modal {...props} data-testid="upsale-modal">
        <ModalHeader className={cx(styles.header, styles.customHeader)}>
          <PlanCard.Name variant="body-1" />
          <PlanCard.Description variant="h2" />
        </ModalHeader>
        <ModalContent>
          <header>
            <PlanCard.Legal />
            <PlanCard.Price />
          </header>

          <PlanCard.FeatureTitle margin="default" />
          <PlanCard.Features />
          <ContactSalesCta onSent={props?.onHide}>
            {L.UPSALE_CUSTOM_CTA}
          </ContactSalesCta>
        </ModalContent>
      </Modal>
    </PlanCard.Root>
  );
};

export default CustomPlanModal;
